module.exports = __webpack_public_path__ + "img/add.44473b51.svg";